/* istanbul ignore file */
import React from 'react';

import { DelayedSuspense } from '@lumapps/lumx-suspense/components/DelayedSuspense';

import { PostDeleteDialogProps } from './PostDeleteDialog';

const LazyPostDeleteDialog = React.lazy(
    () =>
        import(
            /* webpackChunkName: 'post-delete-dialog' */
            './PostDeleteDialog'
        ),
);

export const PostDeleteDialog = (props: PostDeleteDialogProps) => {
    const { isOpen, ...otherProps } = props;

    return (
        <DelayedSuspense shouldLoad={isOpen}>
            <LazyPostDeleteDialog isOpen={isOpen} {...otherProps} />
        </DelayedSuspense>
    );
};
